module.exports = __webpack_public_path__ + "img/skill-i.c30d431c.png";